import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="max-w-[1100px] mx-auto px-5 md:px-10 py-16 md:py-24">
      <div className="max-w-3xl mb-16">
        <div className="ie-overline text-brand-accent mb-4">
          Legal
        </div>

        <h1 className="font-serif text-5xl md:text-6xl tracking-tight">
          Terms & Conditions
        </h1>

        <p className="text-text-secondary text-sm leading-7 mt-6">
          These terms describe the basic conditions for using the
          INDUS EIRENE website and placing an order.
        </p>

        <p className="ie-overline text-text-secondary mt-5">
          Last updated · September 2026
        </p>
      </div>

      <div className="max-w-3xl space-y-12 text-sm leading-7 text-text-secondary">
        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            1. About These Terms
          </h2>
          <p>
            By accessing or using the INDUS EIRENE website, you agree to
            follow these Terms & Conditions. If you do not agree with these
            terms, please do not use the website.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            2. Products & Availability
          </h2>
          <p>
            We make reasonable efforts to display product information,
            photographs, colours, sizes and availability accurately. Product
            availability may change without notice.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            3. Pricing
          </h2>
          <p>
            Prices displayed on the website are shown in Indian Rupees unless
            otherwise stated. Prices and offers may change from time to time.
            Applicable taxes and charges will be presented during checkout.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            4. Orders
          </h2>
          <p>
            An order is subject to successful payment or confirmation of the
            selected payment method and availability of the requested
            products. We reserve the right to cancel an order where necessary,
            including in cases of incorrect pricing, unavailable inventory or
            suspected misuse.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            5. Payments
          </h2>
          <p>
            Online payments are processed through our authorised payment
            provider. Payment information is handled according to the
            provider's applicable terms and security practices.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            6. Shipping & Returns
          </h2>
          <p>
            Shipping, delivery and return conditions are described in our
            applicable customer-care policies.
          </p>

          <div className="flex flex-wrap gap-4 mt-5">
            <Link to="/shipping" className="ie-btn-ghost">
              Shipping
            </Link>

            <Link to="/returns" className="ie-btn-ghost">
              Returns
            </Link>
          </div>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            7. Website Use
          </h2>
          <p>
            You agree not to misuse the website, interfere with its operation,
            attempt unauthorised access or use the website for unlawful
            purposes.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            8. Intellectual Property
          </h2>
          <p>
            Website content including brand names, logos, text, photographs,
            graphics and other materials belongs to INDUS EIRENE or its
            respective licensors and may not be reproduced without
            permission.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            9. Changes
          </h2>
          <p>
            We may update these terms when necessary. The latest version will
            be published on this page.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            10. Contact
          </h2>
          <p>
            Questions regarding these terms can be sent to:
          </p>

          <a
            href="mailto:care@induseirene.in"
            className="inline-block mt-3 text-foreground hover:text-brand-accent"
          >
            care@induseirene.in
          </a>
        </section>
      </div>

      <div className="max-w-3xl mt-16 pt-8 border-t border-border flex flex-wrap gap-4">
        <Link to="/privacy" className="ie-btn-ghost">
          Privacy Policy
        </Link>

        <Link to="/contact" className="ie-btn-ghost">
          Contact
        </Link>
      </div>
    </div>
  );
}